const FormatDateTime = (datetime, type = null) => {
    if (!datetime) return "N/A";

    let safeDatetime = datetime;

    const hasTimezone = /Z$|GMT|[+-]\d{2}:?\d{2}$/.test(datetime);

    if (!hasTimezone) {
        safeDatetime = datetime + "Z";
    }

    const date = new Date(safeDatetime);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    if (type === "date_only") {
        return `${day}/${month}/${year}`;
    }

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
};

export default FormatDateTime;